import { useRouter } from 'next/router';
import React from 'react';
import { Image, ImageCard, ImageTag } from './styled';
import Link from 'next/link';
import { removeDefaultParams } from '../../../Utils/helper';
import { fireClickedCardEvent } from '../../../Utils/useFirebase';

export default function RelatedArticlesCard(props) {
  const { itemData, title } = props;
  const router = useRouter();
  const relatedArticleHandler = (name) => {
    localStorage.setItem('category_img', itemData.image);
    fireClickedCardEvent(
      title,
      itemData?.description,
      title?.includes('article') ? 'article_detail_page' : 'topic_detail_page',
      itemData?.term_id || itemData?.id,
    );
  };
  return (
    <Link
      href={{
        pathname: itemData?.webUrl || itemData?.web_url,
        query: removeDefaultParams(router.query),
      }}
      passHref
      locale={false}
    >
      <ImageCard onClick={() => relatedArticleHandler(itemData?.term_id)}>
        <Image src={itemData.image} alt="" />
        <ImageTag>{itemData.description}</ImageTag>
      </ImageCard>
    </Link>
  );
}
